import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /admin parent route — redirects the bare /admin URL to /admin/login.
 *
 * Mirrors the legacy ``backend/routers/pages.py`` behavior which served
 * admin-login.html for both ``/admin`` and ``/admin/login``. Child
 * routes (``admin.login`` + ``admin.dashboard``) render through the
 * Outlet below.
 *
 * Chrome-less: ``/admin`` is in ``AUTH_PATH_PREFIXES`` so the customer
 * navbar never appears.
 */
export const Route = createFileRoute('/admin')({
  beforeLoad: ({ location }) => {
    // Only redirect the bare /admin (or /admin/) — children handle their own paths.
    if (location.pathname === '/admin' || location.pathname === '/admin/') {
      throw redirect({ to: '/admin/login' });
    }
  },
  component: () => <Outlet />,
});
